import { FunctionComponent, useEffect } from 'react';

import { Skeleton } from '@mui/material';

import Avatar from '../../../shared/components/ui/Avatar';
import Box from '../../../shared/components/ui/Box/Box';
import { tableBlack } from '../../../shared/components/ui/Table/theme/variables/variables';
import Typography from '../../../shared/components/ui/Typography';
import { useImageIsLoaded } from '../AppsTable/hooks/use-is-image-loaded/use-is-image-loaded.hook';
import { useNavigateOnEdit } from './hooks/use-navigate-on-edit/use-navigate-on-edit.hook';
import { TableAppsNameCellProps } from './models/table-apps-name-cell-props.model';

const TableAppsNameCell: FunctionComponent<TableAppsNameCellProps> = ({
  row,
  imageLoadFn,
}: TableAppsNameCellProps) => {
  const navigateToEditPage = useNavigateOnEdit(row.id);

  const isLoaded = useImageIsLoaded(row.icon);

  useEffect(() => {
    if (isLoaded) {
      imageLoadFn();
    }
  }, [isLoaded, imageLoadFn]);

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
      }}
    >
      {isLoaded ? (
        <Avatar
          data-testid="app-icon"
          variant="rounded"
          src={row.icon as string}
          onClick={navigateToEditPage}
          sx={{
            borderRadius: '6px',
            opacity: '100%',
            width: '80px',
            height: '80px',
            marginRight: '25px',
            cursor: 'pointer',
            boxShadow: '0px 2px 6px 0px rgba(0, 0, 0, 0.15)',
          }}
        />
      ) : (
        <Skeleton
          variant="rectangular"
          width={80}
          height={80}
          sx={{
            borderRadius: '6px',
            opacity: '100%',
            width: '80px',
            height: '80px',
            marginRight: '25px',
            cursor: 'pointer',
            boxShadow: '0px 2px 6px 0px rgba(0, 0, 0, 0.15)',
          }}
        />
      )}
      <Box component={'div'}>
        <Typography
          sx={{
            fontSize: '24px',
            color: tableBlack,
            marginTop: '8px',
            marginBottom: 0,
            cursor: 'pointer',
          }}
          onClick={navigateToEditPage}
        >
          {row.name}
        </Typography>

        <Typography
          component={'div'}
          sx={{
            color: tableBlack,
            marginBottom: '9px',
          }}
        >
          {row.latestVersion}
        </Typography>
      </Box>
    </Box>
  );
};

export default TableAppsNameCell;
